/**
 * We are storing shop domain timezone values as it's abbreviation in most
 * cases, only in some of them we use directly the time offset (-10h). So
 * we need a dictionary to convert those abbreviation into an offser, so
 * we can work with javascript Dates.
 *
 * List extracted from https://en.wikipedia.org/wiki/List_of_time_zone_abbreviations
 */
interface TimezoneAbbr {
  abbr: string;
  gmt: string;
  name: string;
}

export const timezonesAbbrs: TimezoneAbbr[] = [
  {
    abbr: 'ACDT',
    name: 'Australian Central Daylight Saving Time',
    gmt: '+10:30',
  },
  { abbr: 'ACST', name: 'Australian Central Standard Time', gmt: '+09:30' },
  { abbr: 'ACT', name: 'Acre Time', gmt: '-05' },
  {
    abbr: 'ACWST',
    name: 'Australian Central Western Standard Time (unofficial)',
    gmt: '+08:45',
  },
  { abbr: 'ADT', name: 'Atlantic Daylight Time', gmt: '-03' },
  { abbr: 'AEDT', name: 'Australian Eastern Daylight Saving Time', gmt: '+11' },
  { abbr: 'AEST', name: 'Australian Eastern Standard Time', gmt: '+10' },
  { abbr: 'AET', name: 'Australian Eastern Time', gmt: '+10/UTC+11' },
  { abbr: 'AFT', name: 'Afghanistan Time', gmt: '+04:30' },
  { abbr: 'AKDT', name: 'Alaska Daylight Time', gmt: '-08' },
  { abbr: 'AKST', name: 'Alaska Standard Time', gmt: '-09' },
  { abbr: 'ALMT', name: 'Alma-Ata Time[1]', gmt: '+06' },
  { abbr: 'AMST', name: 'Amazon Summer Time (Brazil)[2]', gmt: '-03' },
  { abbr: 'AMT', name: 'Armenia Time', gmt: '+04' },
  { abbr: 'ANAT', name: 'Anadyr Time[4]', gmt: '+12' },
  { abbr: 'AQTT', name: 'Aqtobe Time[5]', gmt: '+05' },
  { abbr: 'ART', name: 'Argentina Time', gmt: '-03' },
  { abbr: 'AST', name: 'Atlantic Time', gmt: '-04' },
  { abbr: 'AWST', name: 'Australian Western Standard Time', gmt: '+08' },
  { abbr: 'AZOST', name: 'Azores Summer Time', gmt: '+00' },
  { abbr: 'AZOT', name: 'Azores Standard Time', gmt: '-01' },
  { abbr: 'AZT', name: 'Azerbaijan Time', gmt: '+04' },
  { abbr: 'BNT', name: 'Brunei Time', gmt: '+08' },
  { abbr: 'BIOT', name: 'British Indian Ocean Time', gmt: '+06' },
  { abbr: 'BIT', name: 'Baker Island Time', gmt: '-12' },
  { abbr: 'BOT', name: 'Bolivia Time', gmt: '-04' },
  { abbr: 'BRST', name: 'Brasília Summer Time', gmt: '-02' },
  { abbr: 'BRT', name: 'Brasília Time', gmt: '-03' },
  {
    abbr: 'BST',
    name:
      'British Summer Time (British Standard Time from Feb 1968 to Oct 1971)',
    gmt: '+01',
  },
  { abbr: 'BTT', name: 'Bhutan Time', gmt: '+06' },
  { abbr: 'CAT', name: 'Central Africa Time', gmt: '+02' },
  { abbr: 'CCT', name: 'Cocos Islands Time', gmt: '+06:30' },
  { abbr: 'CDT', name: 'Central Daylight Time (North America)', gmt: '-05' },
  { abbr: 'CEST', name: 'Central European Summer Time', gmt: '+02' },
  { abbr: 'CET', name: 'Central European Time', gmt: '+01' },
  { abbr: 'CHADT', name: 'Chatham Daylight Time', gmt: '+13:45' },
  { abbr: 'CHAST', name: 'Chatham Standard Time', gmt: '+12:45' },
  { abbr: 'CHOT', name: 'Choibalsan Standard Time', gmt: '+08' },
  { abbr: 'CHOST', name: 'Choibalsan Summer Time', gmt: '+09' },
  { abbr: 'CHST', name: 'Chamorro Standard Time', gmt: '+10' },
  { abbr: 'CHUT', name: 'Chuuk Time', gmt: '+10' },
  { abbr: 'CIST', name: 'Clipperton Island Standard Time', gmt: '-08' },
  { abbr: 'CKT', name: 'Cook Island Time', gmt: '-10' },
  { abbr: 'CLST', name: 'Chile Summer Time', gmt: '-03' },
  { abbr: 'CLT', name: 'Chile Standard Time', gmt: '-04' },
  { abbr: 'COST', name: 'Colombia Summer Time', gmt: '-04' },
  { abbr: 'COT', name: 'Colombia Time', gmt: '-05' },
  { abbr: 'CST', name: 'Central Standard Time (North America)', gmt: '-06' },
  { abbr: 'CT', name: 'Central Time', gmt: '-06/UTC-05' },
  { abbr: 'CVT', name: 'Cape Verde Time', gmt: '-01' },
  {
    abbr: 'CWST',
    name: 'Central Western Standard Time (Australia) unofficial',
    gmt: '+08:45',
  },
  { abbr: 'CXT', name: 'Christmas Island Time', gmt: '+07' },
  { abbr: 'DAVT', name: 'Davis Time', gmt: '+07' },
  { abbr: 'DDUT', name: "Dumont d'Urville Time", gmt: '+10' },
  {
    abbr: 'DFT',
    name: 'AIX-specific equivalent of Central European Time[NB 1]',
    gmt: '+01',
  },
  { abbr: 'EASST', name: 'Easter Island Summer Time', gmt: '-05' },
  { abbr: 'EAST', name: 'Easter Island Standard Time', gmt: '-06' },
  { abbr: 'EAT', name: 'East Africa Time', gmt: '+03' },
  {
    abbr: 'ECT',
    name: 'Eastern Caribbean Time (does not recognise DST)',
    gmt: '-04',
  },
  { abbr: 'EDT', name: 'Eastern Daylight Time (North America)', gmt: '-04' },
  { abbr: 'EEST', name: 'Eastern European Summer Time', gmt: '+03' },
  { abbr: 'EET', name: 'Eastern European Time', gmt: '+02' },
  { abbr: 'EGST', name: 'Eastern Greenland Summer Time', gmt: '+00' },
  { abbr: 'EGT', name: 'Eastern Greenland Time', gmt: '-01' },
  { abbr: 'EST', name: 'Eastern Standard Time (North America)', gmt: '-05' },
  { abbr: 'ET', name: 'Eastern Time (North America)', gmt: '-05 / UTC-04' },
  { abbr: 'FET', name: 'Further-eastern European Time', gmt: '+03' },
  { abbr: 'FJT', name: 'Fiji Time', gmt: '+12' },
  { abbr: 'FKST', name: 'Falkland Islands Summer Time', gmt: '-03' },
  { abbr: 'FKT', name: 'Falkland Islands Time', gmt: '-04' },
  { abbr: 'GALT', name: 'Galápagos Time', gmt: '-06' },
  { abbr: 'GAMT', name: 'Gambier Islands Time', gmt: '-09' },
  { abbr: 'GET', name: 'Georgia Standard Time', gmt: '+04' },
  { abbr: 'GFT', name: 'French Guiana Time', gmt: '-03' },
  { abbr: 'GILT', name: 'Gilbert Island Time', gmt: '+12' },
  { abbr: 'GIT', name: 'Gambier Island Time', gmt: '-09' },
  { abbr: 'GMT', name: 'Greenwich Mean Time', gmt: '+00' },
  { abbr: 'GST', name: 'Gulf Standard Time', gmt: '+04' },
  { abbr: 'GYT', name: 'Guyana Time', gmt: '-04' },
  { abbr: 'HDT', name: 'Hawaii–Aleutian Daylight Time', gmt: '-09' },
  {
    abbr: 'HAEC',
    name: "Heure Avancée d'Europe Centrale French-language name for CEST",
    gmt: '+02',
  },
  { abbr: 'HST', name: 'Hawaii–Aleutian Standard Time', gmt: '-10' },
  { abbr: 'HKT', name: 'Hong Kong Time', gmt: '+08' },
  {
    abbr: 'HOVST',
    name: 'Hovd Summer Time (not used from 2017-present)',
    gmt: '+08',
  },
  { abbr: 'HOVT', name: 'Hovd Time', gmt: '+07' },
  { abbr: 'ICT', name: 'Indochina Time', gmt: '+07' },
  { abbr: 'IDLW', name: 'International Day Line West time zone', gmt: '-12' },
  { abbr: 'IOT', name: 'Indian Ocean Time', gmt: '+03' },
  { abbr: 'IRDT', name: 'Iran Daylight Time', gmt: '+04:30' },
  { abbr: 'IRKT', name: 'Irkutsk Time', gmt: '+08' },
  { abbr: 'IRST', name: 'Iran Standard Time', gmt: '+03:30' },
  { abbr: 'IST', name: 'Israel Standard Time', gmt: '+02' },
  { abbr: 'JST', name: 'Japan Standard Time', gmt: '+09' },
  { abbr: 'KALT', name: 'Kaliningrad Time', gmt: '+02' },
  { abbr: 'KGT', name: 'Kyrgyzstan Time', gmt: '+06' },
  { abbr: 'KOST', name: 'Kosrae Time', gmt: '+11' },
  { abbr: 'KRAT', name: 'Krasnoyarsk Time', gmt: '+07' },
  { abbr: 'KST', name: 'Korea Standard Time', gmt: '+09' },
  { abbr: 'LHST', name: 'Lord Howe Standard Time', gmt: '+10:30' },
  { abbr: 'LINT', name: 'Line Islands Time', gmt: '+14' },
  { abbr: 'MAGT', name: 'Magadan Time', gmt: '+12' },
  { abbr: 'MART', name: 'Marquesas Islands Time', gmt: '-09:30' },
  { abbr: 'MAWT', name: 'Mawson Station Time', gmt: '+05' },
  { abbr: 'MDT', name: 'Mountain Daylight Time (North America)', gmt: '-06' },
  { abbr: 'MET', name: 'Middle European Time (same zone as CET)', gmt: '+01' },
  {
    abbr: 'MEST',
    name: 'Middle European Summer Time (same zone as CEST)',
    gmt: '+02',
  },
  { abbr: 'MHT', name: 'Marshall Islands Time', gmt: '+12' },
  { abbr: 'MIST', name: 'Macquarie Island Station Time', gmt: '+11' },
  { abbr: 'MIT  ', name: 'Marquesas Islands Time', gmt: '-09:30' },
  { abbr: 'MMT', name: 'Myanmar Standard Time', gmt: '+06:30' },
  { abbr: 'MSK', name: 'Moscow Time', gmt: '+03' },
  { abbr: 'MST', name: 'Mountain Standard Time (North America)', gmt: '-07' },
  { abbr: 'MUT', name: 'Mauritius Time', gmt: '+04' },
  { abbr: 'MVT', name: 'Maldives Time', gmt: '+05' },
  { abbr: 'MYT', name: 'Malaysia Time', gmt: '+08' },
  { abbr: 'NCT', name: 'New Caledonia Time', gmt: '+11' },
  { abbr: 'NDT', name: 'Newfoundland Daylight Time', gmt: '-02:30' },
  { abbr: 'NFT', name: 'Norfolk Island Time', gmt: '+11' },
  { abbr: 'NOVT', name: 'Novosibirsk Time [9]', gmt: '+07' },
  { abbr: 'NPT', name: 'Nepal Time', gmt: '+05:45' },
  { abbr: 'NST', name: 'Newfoundland Standard Time', gmt: '-03:30' },
  { abbr: 'NT', name: 'Newfoundland Time', gmt: '-03:30' },
  { abbr: 'NUT', name: 'Niue Time', gmt: '-11' },
  { abbr: 'NZDT', name: 'New Zealand Daylight Time', gmt: '+13' },
  { abbr: 'NZST', name: 'New Zealand Standard Time', gmt: '+12' },
  { abbr: 'OMST', name: 'Omsk Time', gmt: '+06' },
  { abbr: 'ORAT', name: 'Oral Time', gmt: '+05' },
  { abbr: 'PDT', name: 'Pacific Daylight Time (North America)', gmt: '-07' },
  { abbr: 'PET', name: 'Peru Time', gmt: '-05' },
  { abbr: 'PETT', name: 'Kamchatka Time', gmt: '+12' },
  { abbr: 'PGT', name: 'Papua New Guinea Time', gmt: '+10' },
  { abbr: 'PHOT', name: 'Phoenix Island Time', gmt: '+13' },
  { abbr: 'PHT', name: 'Philippine Time', gmt: '+08' },
  { abbr: 'PHST', name: 'Philippine Standard Time', gmt: '+08' },
  { abbr: 'PKT', name: 'Pakistan Standard Time', gmt: '+05' },
  { abbr: 'PMDT', name: 'Saint Pierre and Miquelon Daylight Time', gmt: '-02' },
  { abbr: 'PMST', name: 'Saint Pierre and Miquelon Standard Time', gmt: '-03' },
  { abbr: 'PONT', name: 'Pohnpei Standard Time', gmt: '+11' },
  { abbr: 'PST', name: 'Pacific Standard Time (North America)', gmt: '-08' },
  { abbr: 'PWT', name: 'Palau Time[10]', gmt: '+09' },
  { abbr: 'PYST', name: 'Paraguay Summer Time[11]', gmt: '-03' },
  { abbr: 'PYT', name: 'Paraguay Time[12]', gmt: '-04' },
  { abbr: 'RET', name: 'Réunion Time', gmt: '+04' },
  { abbr: 'ROTT', name: 'Rothera Research Station Time', gmt: '-03' },
  { abbr: 'SAKT', name: 'Sakhalin Island Time', gmt: '+11' },
  { abbr: 'SAMT', name: 'Samara Time', gmt: '+04' },
  { abbr: 'SAST', name: 'South African Standard Time', gmt: '+02' },
  { abbr: 'SBT', name: 'Solomon Islands Time', gmt: '+11' },
  { abbr: 'SCT', name: 'Seychelles Time', gmt: '+04' },
  { abbr: 'SDT', name: 'Samoa Daylight Time', gmt: '-10' },
  { abbr: 'SGT', name: 'Singapore Time', gmt: '+08' },
  { abbr: 'SLST', name: 'Sri Lanka Standard Time', gmt: '+05:30' },
  { abbr: 'SRET', name: 'Srednekolymsk Time', gmt: '+11' },
  { abbr: 'SRT', name: 'Suriname Time', gmt: '-03' },
  { abbr: 'SST', name: 'Singapore Standard Time', gmt: '+08' },
  { abbr: 'SYOT', name: 'Showa Station Time', gmt: '+03' },
  { abbr: 'TAHT', name: 'Tahiti Time', gmt: '-10' },
  { abbr: 'THA', name: 'Thailand Standard Time', gmt: '+07' },
  { abbr: 'TFT', name: 'French Southern and Antarctic Time[13]', gmt: '+05' },
  { abbr: 'TJT', name: 'Tajikistan Time', gmt: '+05' },
  { abbr: 'TKT', name: 'Tokelau Time', gmt: '+13' },
  { abbr: 'TLT', name: 'Timor Leste Time', gmt: '+09' },
  { abbr: 'TMT', name: 'Turkmenistan Time', gmt: '+05' },
  { abbr: 'TRT', name: 'Turkey Time', gmt: '+03' },
  { abbr: 'TOT', name: 'Tonga Time', gmt: '+13' },
  { abbr: 'TVT', name: 'Tuvalu Time', gmt: '+12' },
  { abbr: 'ULAST', name: 'Ulaanbaatar Summer Time', gmt: '+09' },
  { abbr: 'ULAT', name: 'Ulaanbaatar Standard Time', gmt: '+08' },
  { abbr: 'UTC', name: 'Coordinated Universal Time', gmt: '+00' },
  { abbr: 'UYST', name: 'Uruguay Summer Time', gmt: '-02' },
  { abbr: 'UYT', name: 'Uruguay Standard Time', gmt: '-03' },
  { abbr: 'UZT', name: 'Uzbekistan Time', gmt: '+05' },
  { abbr: 'VET', name: 'Venezuelan Standard Time', gmt: '-04' },
  { abbr: 'VLAT', name: 'Vladivostok Time', gmt: '+10' },
  { abbr: 'VOLT', name: 'Volgograd Time', gmt: '+03' },
  { abbr: 'VOST', name: 'Vostok Station Time', gmt: '+06' },
  { abbr: 'VUT', name: 'Vanuatu Time', gmt: '+11' },
  { abbr: 'WAKT', name: 'Wake Island Time', gmt: '+12' },
  { abbr: 'WAST', name: 'West Africa Summer Time', gmt: '+02' },
  { abbr: 'WAT', name: 'West Africa Time', gmt: '+01' },
  { abbr: 'WEST', name: 'Western European Summer Time', gmt: '+01' },
  { abbr: 'WET', name: 'Western European Time', gmt: '+00' },
  { abbr: 'WIB', name: 'Western Indonesian Time', gmt: '+07' },
  { abbr: 'WIT', name: 'Eastern Indonesian Time', gmt: '+09' },
  { abbr: 'WITA', name: 'Central Indonesia Time', gmt: '+08' },
  { abbr: 'WGST', name: 'West Greenland Summer Time[14]', gmt: '-02' },
  { abbr: 'WGT', name: 'West Greenland Time[15]', gmt: '-03' },
  { abbr: 'WST', name: 'Western Standard Time', gmt: '+08' },
  { abbr: 'YAKT', name: 'Yakutsk Time', gmt: '+09' },
  { abbr: 'YEKT', name: 'Yekaterinburg Time', gmt: '+05' },
];
